<template>
  <v-container fluid>
    <v-row dense no-gutters>
      <v-col class="pa-4">
        <p class="process-repair-tab-section-title">{{$t("pages.contact.listTitle")}}</p>
        <main-data-table
        ref="tableRef"
        number-pages
        :headers="headers"
        :items="items"
        :page.sync="page"
        :size.sync="size"
        :loading="loading"
        @fetch="tryToFetchContacts"
        :total-elements="totalElements"
        :keyword.sync="keyword"
        :sort-by.sync="sortBy"
        :sort-dir.sync="sortDir">
          <template v-slot:[`item.id`]="{ item }">
              <span>
                {{item.id}}
              </span>
          </template>
          <template v-slot:[`item.username`]="{ item }">
              <span>
                {{item.username}}
              </span>
          </template>
          <template v-slot:[`item.role`]="{ item }">
              <span>
                {{$t(getRole(item.role))}}
              </span>
          </template>
          <template v-slot:[`item.locked`]="{ item }">
              <div class="d-flex justify-space-between align-center">
                <span v-if="!item.locked" class="green--text">
                  {{$t('textFields.unlocked')}}
                </span>
                <span v-else class="red--text">
                  {{$t('textFields.locked')}}
                </span>

                <icon-button
                v-if="item.canLock"
                :src="item.locked ? 'lock-open' : 'lock'"
                :color="item.locked ? 'green' : 'red'"
                :large="false"
                :loading="loading"
                @click="tryToUpdateLockState(item)"/>
              </div>
          </template>
          <template v-slot:[`item.details`]="{ item }">
              <v-btn 
              @click="routeToUser(item.username)"
              class="detail-btn rounded-0" 
              width="70" 
              height="30">
                {{$t('btns.edit')}}
              </v-btn>
          </template>
        </main-data-table>
      </v-col>
    </v-row>

    <export-xlsx-row
    :width="150"
    :height="50"
    :disabled="items.length === 0"
    :loading.sync="loading"
    class="px-4"
    name="export.title.users"
    :exporter="getExporter"/>
  </v-container>
</template>
<script>
import { fetchContactsByCriteria, updateContactLockState } from '@/repositories/contactRepo'
import { routeFromRoot } from '@/services/routeService'
import { execHttpRequestThrowable } from '@/services/http'
import { getRoleByKey } from '@/utils/rolesUtil'
import { isLanguageEn } from '@/services/authService'
import { exportUsersXlsx } from '@/repositories/exportRepo'
import { encodeUrlString } from "@/utils/url.utils"

import MainDataTable from '@/components/common/MainDataTable'
import ExportXlsxRow from '@/components/common/ExportXlsxRow'
import IconButton from '@/components/btns/IconButton'
export default {
  components: {
    MainDataTable,
    ExportXlsxRow,
    IconButton
  },
  data() {
    return {
      headers: [
        {
          text: 'headers.userId',
          align: 'start',
          sortable: true,
          value: 'id'
        }, {
          text: 'headers.fullName',
          align: 'start',
          sortable: true,
          value: 'fullName',
          columnName: "full_name" //native
        }, {
          text: 'headers.username',
          align: 'start',
          sortable: true,
          value: 'username'
        }, {
          text: 'headers.role',
          align: 'start',
          sortable: true,
          value: 'role'
        }, {
          text: 'headers.status',
          align: 'start',
          sortable: true,
          value: 'locked'
        }, {
          text: 'headers.details',
          align: 'start',
          sortable: false,
          value: 'details'
        }
      ],
      sortBy: "role",
      sortDir: "ASC",
      items: [],
      totalElements: 0,
      page: 1,
      size: 10,
      keyword: "",
      loading: false
    }
  },
  computed: {
    isEN() {
      return isLanguageEn()
    },
    getExporter() {
      return async () => await exportUsersXlsx(this.keyword, this.getSort)
    },
    getSort() {
      return `${this.$refs.tableRef.getColumnNameByHeaderValue(this.sortBy)},${this.sortDir}`
    }
  },
  methods: {
    routeTo(link) {
      routeFromRoot(link)
    },
    routeToUser(username) {
      this.routeTo(`edit/contact/${encodeUrlString(username)}`)
    },
    async tryToFetchContacts({search, size, page, sort}) {
      this.items = []
      const r = await execHttpRequestThrowable(async () => await fetchContactsByCriteria(search, size, page - 1, sort), {}, v => this.loading = v)
      const p = r.response.data
      this.totalElements = p.totalElements
      this.items = p.content
    },
    getRole(r) {
      return getRoleByKey(r)
    },
    async tryToUpdateLockState(item) {
      const { username, locked } = item
      const IS_LOCKING = !locked
      await execHttpRequestThrowable(async () => await updateContactLockState(username, IS_LOCKING), {}, v => this.loading = v)

      item.locked = IS_LOCKING
      this.$snackbar.success(`snackbar.success.${IS_LOCKING ? 'userLocked' : 'userUnlocked'}`)
    }
  },
  async mounted() {
    await this.tryToFetchContacts({
      search: this.keyword,
      size: this.size,
      page: this.page,
      sort: this.getSort
    })
  },
  created() {
    this.$feedback.fill("Contact List Page", this.$route.path)
  }
}
</script>
<style>

</style>